import { LaeliaSynth } from '@/components/LaeliaSynth';

export default function App() {
  return <LaeliaSynth />;
}
